module.exports = __webpack_public_path__ + "static/img/1_6.a67850a2.jpg";